export default (str = '', delimiter = ',') =>
  str.split(delimiter).reduce((acc, item) => {
    const trimmed = item.trim();
    if (trimmed.length !== 0) {
      acc.push(trimmed);
    }
    return acc;
  }, []);
